// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHOTO_UPLOAD_WRONG_IMAGE_FORMAT = "Nespr\u00e1vny typ s\u00faboru. M\u00e1 ma\u0165 pr\u00edponu JPG, PNG, GIF alebo WEBP";
